import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../../services/app.service';
import { ProductService } from '../../../../services/products/product.service';
import { ProductSearchRequest } from '../../../../models/net/request/product-search-request';
import { ProductSearchResult } from '../../../../models/net/result/product-search-result';
import { ActivatedRoute } from '@angular/router';
import { TelemetorComponent } from '../../../base/telemetor/telemetor.component';

@Component({
    selector: 'app-product-cards',
    templateUrl: './product-cards.component.html',
    styleUrls: ['./product-cards.component.css', '../../../../app.component.css']
})

export class ProductCardsComponent extends TelemetorComponent implements OnInit {

    public products: ProductSearchResult[] | null = null;
    public isLargeCardDisplay: boolean = false;

    public constructor(public appService: AppService, public productService: ProductService, private route: ActivatedRoute) {

        super();
    }

    public override ngOnInit(): void {

        this.emitTelemetrigram("load");
    }

    public ngAfterViewInit(): void {

        const currentRoute = this.route.snapshot.routeConfig?.path

        let anonymousProductSearchRequest: ProductSearchRequest = new ProductSearchRequest();

        anonymousProductSearchRequest.BasicSearchString.IsWildPrefix = true;
        anonymousProductSearchRequest.BasicSearchString.IsWildSuffix = true;
        anonymousProductSearchRequest.BasicSearchString.SearchString = ""        

        if (currentRoute == "bakedgoods") {

            anonymousProductSearchRequest.IsAdvancedSearch = true;
            anonymousProductSearchRequest.ProductCategoryIds = "2";

        } else if (currentRoute == 'merchandise') {

            anonymousProductSearchRequest.IsAdvancedSearch = true;
            anonymousProductSearchRequest.ProductCategoryIds = "1";

            this.isLargeCardDisplay = true;
        }

        this.productService.anonSearch(anonymousProductSearchRequest).subscribe((r: any | null) => {

            if (r) {

                this.products = r;
            }
        });
    }

    public order = (productId: number): void => {

        this.appService.showPendingFeatureDialog();
    }
}
